import { Button, Checkbox, Flex } from '@chakra-ui/react';
import { find, isEmpty } from 'lodash';
import { TextRegular } from '@components/typography';
import { useNavigate } from 'react-router-dom';
import { useStateParahub } from '@pages/Parahub/hooks/state/useStateParahub';

const ExportCheckbox = ({ values }) => {
    const { exportListParahub } = useStateParahub();

    const isChecked = find(exportListParahub, { id: values?.id });
    return (
        <Flex className={'column__container'}>
            <Checkbox isChecked={!isEmpty(isChecked)} />
        </Flex>
    );
};

export const tableList = [
    {
        name: '',
        value: '',
        width: 80,
        isCheckbox: true,
        component: ({ values }) => <ExportCheckbox values={values} />,
    },
    {
        name: 'Parahub ID',
        value: 'parahub_id',
        withSort: true,
        width: 300,
        component: ({ value }) => (
            <Flex className={'column__container'}>
                <TextRegular>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Parahub',
        value: 'parahub_name',
        withSort: true,
        width: 240,
        component: ({ value }) => (
            <Flex className={'column__container'}>
                <TextRegular>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Customer ID',
        value: 'customer_id',
        withSort: true,
        width: 250,
        component: ({ value }) => (
            <Flex className={'column__container'}>
                <TextRegular>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Customer Name',
        value: 'customer_name',
        withSort: true,
        width: 340,
        component: ({ value }) => (
            <Flex className={'column__container'}>
                <TextRegular>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'POS',
        value: 'pos',
        withSort: true,
        width: 300,
        component: ({ value }) => (
            <Flex className={'column__container'}>
                <TextRegular>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'DC',
        value: 'dc_name',
        withSort: true,
        width: 240,
        component: ({ value }) => (
            <Flex className={'column__container'}>
                <TextRegular>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Sales Area',
        value: 'sales_area_name',
        withSort: true,
        width: 250,
        component: ({ value }) => (
            <Flex className={'column__container'}>
                <TextRegular>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Action',
        value: 'customer_id',
        width: 100,
        sortable: false,
        component: (props) => {
            const navigate = useNavigate();

            const handleClick = () => {
                navigate(`${props.values.customer_id}`);
            };
            return (
                <Flex className={'column__container'}>
                    <Button
                        size={'sm'}
                        variant={'outline'}
                        colorScheme="sagitarius"
                        borderRadius={4}
                        onClick={handleClick}
                    >
                        Config
                    </Button>
                </Flex>
            );
        },
    },
];
